<template lang="pug">
.card
  .card-header
    .card-title(v-if='editavel')
      input.form-input(v-model='planta.tipo' placeholder='Tipo')
    .card-title(v-else) {{ planta.tipo || '&nbsp;' }}
    .card-subtitle.text-gray.text-small {{ planta.nome }}
  .card-image
    a(target='_blank' :href='planta.url')
      img.img-fit-contain(:src='planta.thumb')
  .card-footer
    slot(name='footer')
</template>

<script>
export default {
  props: {
    planta: { type: Object, required: true },
    editavel: { type: Boolean, default: false },
  },
}
</script>

<style lang="stylus" scoped>
.card
  .card-header
    flex 1
  .card-image
    a
      background-color #dadee4
      padding 5px
      display block
      margin 0 5px
      border-radius 5px
      img
        display block
        border-radius 15px
        height 200px
        width 100%
</style>
